import { Injectable } from '@angular/core';
import { Constants } from '@constants/constants';
import { ObservatoryService } from '../observatory/observatory.service';

/**
 * Servicio que se encarga de la gestión de errores.
 */
@Injectable()
export class ErrorService {
  public warnings: object;
  public errors: any;
  constructor(
    private observatoryService: ObservatoryService
    // private _nuar: NuarErrorService
  ) {
    this.warnings = {};
    this.errors = {
      code: '',
      message: ''
    };
  }

  /**
   * FUnción que imprime o registra un error. Los parametros opcionales estan deshabilitados y preparados para ser insertados si hacen falta
   * @param msg Mensaje a imprimir en el error
   * @param userId (optional) Usuario asociado
   * @param subAppVersion (opcional) version de la app
   * @param component (opcional) Componente del que viene el error
   */
  public logError(msg, userId = null, subAppVersion = null, component = null) {
    // const nuarErr = new NuarError(msg, userId, subAppVersion, component);
    // this._nuar.logError(nuarErr);
    console.error(msg);
  }

  /**
   * Función que captura el mensaje de error asociado a un nombre
   * @param name Id del error (id del rest en el caso de gestion de errores de restConn)
   * @returns objeto con value: Codigo del mensaje de error y translate boolean si necesita traduccion
   */
  public getWarning(name) {
    return this.warnings[name];
  }

  /**
   * Función que captura el mensaje de error asociado a un nombre
   * @param name Id del error (id del rest en el caso de gestion de errores de restConn)
   * @returns Codigo del mensaje de error
   */
  public getErrors(): object {
    return this.errors;
  }

  /**
   * Función que añade la key del mensaje de error
   * @param name Id del error (id del rest en el caso de gestion de errores de restConn)
   * @param textValue Codigo del mensaje asociado a ese error
   */
  public addWarning(name: string, textValue: string, needTranslate = true) {
    this.warnings[name] = {
      value: textValue !== 'COMMON.CUSTOM_ERRORS.null' ? textValue : Constants.customWarnings[name],
      translate: needTranslate
    };
  }

  /**
   * Función que quita del listado de errores el mensaje asociado a cierto id
   * @param name Id del error (id del rest en el caso de gestion de errores de restConn)
   */
  public removeWarning(name: string) {
    try {
      delete this.warnings[name];
    } catch (err) {

    }
  }

  /**
   * Función que añade la key del mensaje de error
   * @param name Id del error (id del rest en el caso de gestion de errores de restConn)
   * @param textValue Codigo del mensaje asociado a ese error
   */
  public addCustomError(name: string, extraData: object, titleError?: string, forceText?: boolean) {
    let code = '';
    if (extraData['code']) {
      if (extraData['code'].indexOf('.') > -1) {
        code = extraData['code'];
      } else {
        code = 'COMMON.CUSTOM_ERRORS.' + extraData['code'];
      }
    } else {
      code = '';
    }
    this.errors = {
      code: code,
      title: titleError ? titleError : '',
      message: extraData['message'] ? extraData['message'] : '',
      mode: extraData['mode'] ? extraData['mode'] : '',
      forceText: (forceText) ? true : false,
      icon: extraData['icon'] ? extraData['icon'] : '',
      colorText: extraData['colorText'] ? extraData['colorText'] : ''
    };
    this.observatoryService.setData('customerror', true);
  }

  /**
   * Función que libera el componente de custom errors vaciando el campo en el observatory
   */
  public resetCustomErrors() {
    this.observatoryService.setData('customerror', false);
  }


  /**
   * Función que comprueba si hay algun error asoaciado a un id
   * @param name Id del error (id del rest en el caso de gestion de errores de restConn)
   * @returns boolean informando si hay algun error asociado
   */

  public hasWarning(name: string): boolean {
    return typeof this.warnings[name] === 'object'; // && typeof this.warnings[name].value === 'string';
  }

  /**
   * Función que comprueba si hay algun error asoaciado a un id
   * @param name Id del error (id del rest en el caso de gestion de errores de restConn)
   * @returns boolean informando si hay algun error asociado
   */

  public hasErrors(): boolean {
    return this.errors ? true : false;
  }

  /**
   * Función que quita del listado de errores el mensaje asociado a cierto id
   */
  public removeAllWarning() {
    try {
      this.warnings = {};
    } catch (err) {

    }
  }

  /**
   * Función que quita del listado de errores el mensaje asociado a cierto id
   */
  public removeAllErrors() {
    try {
      this.errors = {};
    } catch (err) {

    }
  }

  /**
   * Complementary function for ngOnDestroy
   */
  public emptyErrors() {
    this.removeAllErrors();
    this.removeAllWarning();
    this.resetCustomErrors();
  }

}
